import {Button, ButtonProps} from '@chakra-ui/react';
import {ReactElement, ReactNode} from 'react';

interface WhiteButtonProps extends Omit<ButtonProps, 'leftIcon'> {
  texte: ReactNode;
  leftIcon?: ReactElement;
}

export const WhiteButton: React.FC<WhiteButtonProps> = ({
  texte,
  leftIcon,
  ...props
}) => {
  return (
    <Button
      bgColor='white'
      size='sm'
      bg='white'
      color='blue.main'
      borderColor='blue.main'
      border='1px solid'
      h='35px'
      fontWeight='600'
      transition='all 0.2s ease-in-out'
      cursor='pointer'
      whiteSpace={{base: 'normal', md: 'nowrap'}}
      wordBreak='break-word'
      leftIcon={leftIcon}
      _hover={{bg: 'blue.dark', borderColor: 'white', color: 'white'}}
      {...props}
    >
      {texte}
    </Button>
  );
};
